import { cva } from 'class-variance-authority';
import { ArrowLeft } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import routes from '@/shared/constants/routesPath';
import useUserStore from '@/shared/store/user';
import { cn } from '@/shared/utils';

import Logo from '@/components/ui/Logo';
import Button from '@/components/ui/button';

const navbarVariants = cva(
  [
    'flex min-h-[60px] items-center',
    'flex-wrap gap-2 bg-black/50 p-2 backdrop-blur-sm',
    'md:min-h-[84px] md:px-6 md:py-2.5',
    'fixed left-0 right-0 top-0 z-20',
    'xl:min-h-navbar-desktop',
  ],
  {
    variants: {
      type: {
        simple: 'justify-center',
        complex: 'lg:pl-2',
      },
    },
    defaultVariants: {
      type: 'complex',
    },
  }
);

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useUserStore();

  const isHomePage = location.pathname === routes.HOME;
  const isLiveScoringPage = location.pathname.includes(
    routes.LIVESCORING.split('/')[1]
  );
  const type = isHomePage ? 'simple' : 'complex';

  const handleBack = () => {
    // if (window.history.length > 1) {
    //   navigate(-1);
    // } else {
    navigate(routes.HOME);
    // }
  };

  return (
    <nav className={cn(navbarVariants({ type }))}>
      {!isHomePage && (
        <Button variant="icon" size="icon" onClick={handleBack}>
          <ArrowLeft />
        </Button>
      )}

      <div
        className={cn(
          'flex flex-1 justify-center md:gap-3',
          isLiveScoringPage ? 'xl:justify-start' : ''
        )}
      >
        <Link to={routes.HOME}>
          <Logo />
        </Link>
      </div>

      <div
        className={cn(
          'max-[510px]:w-full max-[510px]:text-center',
          !isHomePage ? 'min-[510px]:relative md:right-0' : ''
        )}
      >
        {user?.id ? (
          <div className="flex items-center gap-3">
            {/* <div className="h-8 w-8 overflow-hidden rounded-full">
              <img src={`https://picsum.photos/200?random=${Math.random()}`} alt="Random avatar" />
            </div> */}
            <Button variant="link" size="icon" onClick={logout}>
              Logout
            </Button>
          </div>
        ) : (
          <Button asChild>
            <Link to={routes.LOGIN}>Login</Link>
          </Button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
